<!--
  @Description 工作量评估弹窗
  @Date 2021-12-31
  @Author liushuo
-->
<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="工作量评估"
    width="300px"
    @show="showModal"
  >
    <div class="tooltip">{{ `请输入 ${step} 的倍数` }}</div>
    <el-input-number
      v-model="num"
      :precision="2"
      :step="step"
      :max="maxNum"
      :min="minNum"
      step-strictly
    ></el-input-number>
    <el-button
      @click="handleCommit"
      style="float: right; margin-top: 10px"
      size="mini"
      type="primary"
      >确认</el-button
    >
  </vxe-modal>
</template>
<script>
import { MessageBox } from 'element-ui'
export default {
  name: 'workTimeSelect',
  data() {
    return {
      formVisible: false,
      num: 1,
      // 是否能调整大于等于2天的工作量
      isCanMoreThanTwoDay: false,
      // 无特殊权限，默认只能设置 <=2 天
      maxNum: 2,
      minNum: 0,
      // 区间值
      step: 0.1,
      // 当前选中行的id
      rowID: -1,
      // 当前选中行的类型 [前端评价人、后端评价人]
      type: '',
    }
  },
  methods: {
    showModal() {
      this.getSpecial()
    },
    // 获取特殊权限
    getSpecial() {
      this.isCanMoreThanTwoDay = !!this.$parent.specialAuthority.worktime
      if (this.isCanMoreThanTwoDay) {
        // 特殊权限可以设置任意天数
        this.maxNum = Infinity
      }
    },
    // 提交
    async handleCommit() {
      if (this.num === 0) {
        MessageBox.confirm('该提交将导致工作量为 0，确认是否提交？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.httpCommit()
          })
          .catch(() => {})
        return
      }

      this.httpCommit()
    },

    // 发起提交请求
    async httpCommit() {
      const idList = [this.rowID]

      const { data: res } = await this.$http.post('/Common/YKCase/worktime', {
        iDs: idList,
        type: this.type,
        workTime: this.num,
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      // 重新刷新主页面（局部刷新）
      this.$parent.getListPart(idList)
      // this.$parent.getList(false, false)

      this.$nextTick(() => {
        this.formVisible = false
      })
    },
  },
}
</script>
<style lang="less" scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}

.tooltip {
  margin-bottom: 5px;
  color: #999;
}
</style>
